import { CommercialBookListPresenter } from "./presenter";

export const CommercialBookListContainer: React.FC = () => {
  return <CommercialBookListPresenter />;
};
